import ImprimirButton from '@/global/components/DataGrid/components/CustomGridToolBar/ImprimirButton'
import { GridButton } from '@/global/components/DataGrid/components/CustomGridToolBar/MenuComponents'
import { FooterAviso } from '@/global/components/DataGrid/components/DataTable/Footer'
import useDefaultFilterModel from '@/global/components/DataGrid/hooks/useDefaultFilterModel'
import useDefaultSortModel from '@/global/components/DataGrid/hooks/useDefaultSortModel'
import FilterModelPro from '@/global/components/DataGrid/utils/filterModelPro'
import { Link } from '@/global/components/Link'
import {
    EscopoFuncionario,
    useEscopoFuncionario,
} from '@/global/components/EscopoFuncionario'
import { useFilterLocaisCentroStore } from '@/global/components/Selects/filter-select'
import { hasPermission } from '@/hooks/useBackendMenu'
import SelectCompetencia, {
    useCompetencia,
} from 'global/components/Selects/SelectCompetencia'
import ContentGuide from 'global/guides/ContentGuide'
import { HistoryIcon } from 'lucide-react'
import { useState } from 'react'
import { Ajustes, ajustes } from 'service/api'
import { useStore } from 'store'
import { columnsRelatorio as columns } from 'templates/ManutencaoDoPonto/Ajuste/constants/columns'

export default function RelatorioAjustes() {
    const [isImprimindo, setIsImprimindo] = useState(false)
    const [competencia, setCompetencia] = useCompetencia()
    const empresaId = useStore(state => state.companyId)
    const [escopo, setEscopo] = useEscopoFuncionario()
    const { data, isLoading } = ajustes.relatorio.useFetch(false, {
        queryParams: {
            empresaId,
            competencia,
        },
        enabled: empresaId > 0,
    })
    const [filterModel, setFilterModel] = useDefaultFilterModel()
    const [sortModel, setSortModel, sort] = useDefaultSortModel(columns)

    const useFilter = useFilterLocaisCentroStore()
    const rows = new Ajustes(data).ajustes
        .filter(useFilter)
        .map(ajuste => ({
            ...ajuste,
            nome: ajuste.Funcionario.nome,
        }))
        .sort((a, b) => {
            return a.nome.localeCompare(b.nome)
        })

    const handleClick = async () => {
        setIsImprimindo(true)
        const mappedData = sort(
            rows.filter(new FilterModelPro(filterModel, columns).filter),
        ).map(ajuste => ajuste.id)

        ajustes
            .pdf({
                data: JSON.stringify(mappedData),
                queryParam: {
                    empresaId,
                    competencia,
                },
            })
            .finally(() => {
                setIsImprimindo(false)
            })
    }

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Relatórios', 'Ajustes']}>
                    <EscopoFuncionario.Root value={escopo} onChange={setEscopo}>
                        <EscopoFuncionario.Cascata>
                            <EscopoFuncionario.Trigger
                                variant="filled"
                                size="md"
                            />
                            <EscopoFuncionario.Empresa />
                            <EscopoFuncionario.CentrosCusto multiple />
                            <EscopoFuncionario.Locais multiple />
                            <EscopoFuncionario.Funcionarios multiple />
                        </EscopoFuncionario.Cascata>
                    </EscopoFuncionario.Root>
                    <ContentGuide.Filtros>
                        <SelectCompetencia
                            onChange={setCompetencia}
                            value={competencia}
                        />
                    </ContentGuide.Filtros>
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    {...{ rows, columns, filterModel, sortModel }}
                    loading={isLoading}
                    onFilterModelChange={setFilterModel}
                    onSortModelChange={setSortModel}
                    components={{
                        Toolbar: () => [
                            hasPermission(
                                ['read', 'AssinaturaEletrônicaDeAjustes'],
                                () => (
                                    <GridButton
                                        key="historico"
                                        href="impressos"
                                        startIcon={<HistoryIcon />}
                                        label="Histórico"
                                    />
                                ),
                            ),
                            <div key="flex" style={{ flex: 1 }} />,
                            <ImprimirButton
                                key="imprimir"
                                handleClick={handleClick}
                                isImprimindo={isImprimindo}
                            />,
                        ],
                        Footer: () => (
                            <FooterAviso>
                                Os relatórios gerados nessa tela não possuem
                                assinatura eletrônica ou validade jurídica.
                                {hasPermission([
                                    'create',
                                    'AssinaturaEletrônicaDeAjustes',
                                ]) && (
                                    <span>
                                        {' '}
                                        Para baixar os relatórios assinados,
                                        acesse{' '}
                                        <Link href="impressos">Impressos</Link>.
                                    </span>
                                )}
                            </FooterAviso>
                        ),
                    }}
                    tableId="relatorio-ajustes"
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-ajustes-realizados',
                        },
                        showVisibilityButton: true,
                    }}
                />
            </ContentGuide.Card>
        </ContentGuide>
    )
}
